import React, { useEffect, useState } from 'react'
import { userAvatar } from '../utils'
import { updateCourseDocumentIsPublic, updateCourseDocumentRefereeVisible, updateCourseDocumentStar } from '../utils/Network'

export default function CourseDocumentSingle({ coursedocument, callback}) {

    const [referee_visible, setRefereeVisible] = useState(null)
    const [is_public, setPublic] = useState(null)
    const [star, setStar] = useState(0)
    const [refresh, setRefresh] = useState(0)

    useEffect(() => {


        if (coursedocument){
            setRefereeVisible(coursedocument.referee_visible)
            setPublic(coursedocument.public)
            setStar(coursedocument.star)
            setRefresh(refresh+1)
        }
        
    }, [coursedocument])

    

    const updateRefereeVisible = () => {
        updateCourseDocumentRefereeVisible(coursedocument.id, !referee_visible).then(data => {
            setRefereeVisible(!referee_visible)
        })
    }

    const updateIsPublic = () => {
        if (!coursedocument?.id) return
        updateCourseDocumentIsPublic(coursedocument.id, !is_public).then(data => {
            setPublic(!is_public)
        })
    }

    const updateStar = (value) => {
        setStar(value)
        updateCourseDocumentStar(coursedocument.id, value).then(data => {
        })
    }

    const profile = coursedocument?.userdocument?.usertalent?.user?.profile
    const displayName = profile
        ? [profile.first_name, profile.last_name].filter(Boolean).join(' ').trim() || '—'
        : '—'
    const avatarSrc = profile ? userAvatar(profile) : '/assets/dist/img/avatar-m.jpeg'

    const openPreview = () => {
        callback(coursedocument.userdocument)
    }

    const onMediaKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            openPreview()
        }
    }

    return (
        <div className="coursedocument-container coursedocument-container--grid">
            <div
                className="widget-user-header text-center cms-coursedocument-card-media"
                onClick={openPreview}
                onKeyDown={onMediaKeyDown}
                role="button"
                tabIndex={0}
            >
                <div className="widget-user-image">
                    <img
                        src={avatarSrc}
                        alt={displayName}
                        className="img-circle img-rating cms-ratings-avatar"
                    />
                </div>
                <div className="cms-coursedocument-card__name kfont">{displayName}</div>
            </div>
            <div className="btns coursedocument-btns-row">
                <button type="button" title="show for referees' rating" onClick={updateRefereeVisible} className={`btn btn-cm coursedocument-action-btn ${referee_visible ? "btn-cm-success" : "btn-cm-warning"}`}><i className="fa fa fa-gavel"></i></button>
                <button type="button" title="show for public rating" onClick={updateIsPublic} className={`btn btn-cm coursedocument-action-btn ${is_public ? "btn-cm-success" : "btn-cm-warning"}`}><i className="fa fa-users"></i></button>
                <select className="form-control coursedocument-sort-select" title="Sort index for referee rating and public view"
                 value={star}
                 onChange={(e)=>{  updateStar(e.target.value) }}>
                    {[...Array(100)].map((x, i) =>
                        <option key={i + 1} value={i+1}>{i+1}</option>
                    )}
                </select>
                <button type="button" className="btn btn-cm btn-cm-danger coursedocument-btn-trash"><i className="fa fa-trash"></i></button>
            </div>

        </div>
    )
}
